// extracted by mini-css-extract-plugin
export var cardIcon = "_70-4";
export var checkboxCard = "_70-0";
export var checkboxCardSelected = "_70-3";
export var disabled = "_70-1";
export var outerBorder = "_70-2";
export var spacerMedium = "_70-7";
export var spacerSmall = "_70-6";
export var spacerXsmall = "_70-5";